import React from 'react'
import './AssignUsersToManagerComponent.css'

const AssignUsersToManagerComponent = () => {
  return (
    <div className="banner_section" style={{ flex: 1 }}>
      AssignUsersToManagerComponent
    </div>
  )
}

export default AssignUsersToManagerComponent
